import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import '../styles/InviteLinkModal.css';

export default function InviteLinkModal({ show, onClose }) {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [copied, setCopied] = useState(false);

  // Get invite code from environment (default: chalkandballs)
  const inviteCode = import.meta.env.VITE_INVITE_CODE || 'chalkandballs';

  // Generate invite link with user's username
  const inviteLink = `${window.location.origin}/register?invite=${encodeURIComponent(inviteCode)}&from=${encodeURIComponent(user?.username || '')}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      showToast('Invite link copied to clipboard!', 'success');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
      showToast('Failed to copy link', 'error');
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Join CornerPocket',
          text: `${user?.username || 'I'} invited you to join CornerPocket - Track your pool games and compete with friends!`,
          url: inviteLink,
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Failed to share:', error);
        }
      }
    } else {
      handleCopy();
    }
  };

  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        onClick={onClose}
      >
        <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Invite Friends</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="invite-modal-description">
                Share this link with your friends to invite them to CornerPocket!
              </p>

              <div className="mb-3">
                <label className="invite-modal-label">Your Invite Link</label>
                <div className="invite-input-group">
                  <input
                    type="text"
                    className="invite-input"
                    value={inviteLink}
                    readOnly
                    onClick={(e) => e.target.select()}
                  />
                  <button
                    className={`invite-copy-btn ${copied ? 'copied' : ''}`}
                    onClick={handleCopy}
                  >
                    {copied ? (
                      <>
                        <i className="bi bi-check2"></i> Copied
                      </>
                    ) : (
                      <>
                        <i className="bi bi-clipboard"></i> Copy
                      </>
                    )}
                  </button>
                </div>
              </div>

              <div className="invite-share-btn-container">
                <button className="btn btn-primary w-100" onClick={handleShare}>
                  <i className="bi bi-share"></i> Share Link
                </button>
              </div>

              <div className="invite-info-card">
                <p className="invite-info-text">
                  <i className="bi bi-info-circle"></i>
                  When friends sign up using your link, they'll automatically be added as friends!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
